export default __webpack_public_path__ + "static/screeny-130-ga-6-6e3cda97087d43b3e41d66848fd74acd.jpg";